import { Nil } from '../utils/Nil';
import { api } from './api';

export const SCP_EMAIL = 'scp@collins.com';

export type EmailEntity = {
    too: Nil<string>;
    from: Nil<string>;
    bcc: Nil<string>;
    subject: Nil<string>;
    body: Nil<string>;
};

export async function sendEmail(entity: EmailEntity) {
    const { data } = await api.post<EmailEntity>('Email/SendEmail', entity);
    return data;
}

export async function SendEmailErrorLog(entity: EmailEntity) {
    const { data } = await api.post<EmailEntity>('Email/SendEmailErrorLog', entity);
    return data;
}
